import { Divider, Typography } from 'antd';
import styled from 'styled-components';

import { DEVICE_SIZES } from '../constants/common';

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 16px 60px;

  @media (max-width: ${DEVICE_SIZES.tablet}) {
    padding: 16px;
  }
`;

export const LandingSubtitle = styled(Typography.Title).attrs({ level: 2 })`
  && {
    font-size: 32px;
    margin-bottom: 50px;

    @media (max-width: ${DEVICE_SIZES.tablet}) {
      font-size: 20px;
    }
  }
`;

export const LandingParagraphSmall = styled(Typography.Paragraph)`
  && {
    font-size: 32px;
    font-weight: 100;
    margin-bottom: 32px;
    margin-top: 0;
    color: ${({ theme }) => theme.brandDefault};

    @media (max-width: ${DEVICE_SIZES.tablet}) {
      font-size: 16px;
      font-weight: 300;
    }
  }
`;

export const FeatureTitle = styled(Typography.Text)`
  && {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    display: block;
    width: 100%;
  }
`;

export const FeatureText = styled(Typography.Text)`
  && {
    text-align: center;
    display: block;
  }
`;

export const LandingDivider = styled(Divider)`
  && {
    margin: 80px 0 40px 0;
  }
`;
